import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';
import { EStaticPageName } from '@modules/static-pages/enums';
import { buildObjectFromArray } from '@utils/object';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    common: {
      menu: {
        admin_menu: {
          home: 'ADMIN_HOME',
          partners: {
            group_header: 'PARTNERS_GROUP_HEADER',
            unconfirmed_partners: 'PARTNERS_UNCONFIRMED_PARTNERS',
            new_partners: 'PARTNERS_NEW_PARTNERS',
            partners_list: 'PARTNERS_PARTNERS_LIST',
            requests_history: 'PARTNERS_REQUESTS_HISTORY',
            admin_webhooks_history: 'PARTNERS_ADMIN_WEBHOOKS_HISTORY',
            partners_mailing: 'PARTNERS_PARTNERS_MAILING',
            reports: 'PARTNERS_REPORTS',
            subaffiliate_reports: 'PARTNERS_SUBAFFILIATE_REPORTS',
            creative_reports: 'PARTNERS_CREATIVE_REPORTS',
            admin_balance_adjustments_history: 'PARTNERS_ADMIN_BALANCE_ADJUSTMENTS_HISTORY',
            withdrawals_history: 'PARTNERS_ADMIN_WITHDRAWALS_HISTORY',
            pending_withdrawals: 'PARTNERS_PENDING_WITHDRAWALS',
            partners_balances: 'PARTNERS_PARTNERS_BALANCES',
          },
          finance: {
            group_header: 'FINANCE_GROUP_HEADER',
            payment_system_details_pending_requests: 'FINANCE_PAYMENT_SYSTEM_DETAILS_PENDING_REQUESTS',
            payment_system_details_requests_history: 'FINANCE_PAYMENT_SYSTEM_DETAILS_REQUESTS_HISTORY',
            available_payment_systems: 'FINANCE_AVAILABLE_PAYMENT_SYSTEMS',
          },
          players: {
            group_header: 'PLAYERS_GROUP_HEADER',
            players_list: 'PLAYERS_PLAYERS_LIST',
            bonuses: 'PLAYERS_BONUSES',
            mass_retag: 'PLAYERS_MASS_RETAG',
          },
          partnership: {
            group_header: 'ADMIN_PARTNERSHIP_GROUP_HEADER',
            trackers: 'ADMIN_PARTNERSHIP_TRACKERS',
            promo_codes: 'ADMIN_PARTNERSHIP_PROMO_CODES',
            admin_fees: 'ADMIN_PARTNERSHIP_ADMIN_FEES',
            conditions: 'ADMIN_PARTNERSHIP_CONDITIONS',
            subaffiliate_conditions: 'ADMIN_PARTNERSHIP_SUBAFFILIATE_CONDITIONS',
            bookkeeping: 'ADMIN_PARTNERSHIP_BOOKKEEPING',
            creatives: 'ADMIN_PARTNERSHIP_CREATIVES',
            articles: 'ADMIN_PARTNERSHIP_ARTICLES',
          },
          personnel: {
            group_header: 'PERSONNEL_GROUP_HEADER',
            personnel_list: 'PERSONNEL_PERSONNEL_LIST',
            groups_list: 'PERSONNEL_GROUPS_LIST',
            group_of_managers: 'PERSONNEL_GROUP_OF_MANAGERS',
          },
          system_settings: {
            group_header: 'SYSTEM_SETTINGS_GROUP_HEADER',
            settings: 'SYSTEM_SETTINGS_SETTINGS',
            translate_manager: 'SYSTEM_SETTINGS_TRANSLATE_MANAGER',
            permissions_manager: 'SYSTEM_SETTINGS_PERMISSIONS_MANAGER',
            imported_data: 'SYSTEM_SETTINGS_IMPORTED_DATA',
            quints_api: 'SYSTEM_SETTINGS_QUINTS_API',
          },
          // TODO: Add here all translation keys from general settings tabs when ones will be removed
          general_settings: {
            merchant_settings: 'GENERAL_SETTINGS_MERCHANT_SETTINGS',
            well_known_links: 'GENERAL_SETTINGS_WELL_KNOWN_LINKS',
            welcome_page_redirects: 'GENERAL_SETTINGS_WELCOME_PAGE_REDIRECTS',
          },
          mirrors: {
            group_header: 'MIRRORS_GROUP_HEADER',
            mirrors_list_js: 'MIRRORS_MIRRORS_LIST_JS',
            mirrors_list_no_js: 'MIRRORS_MIRRORS_LIST_NO_JS',
            mirrors_notifications: 'MIRRORS_MIRRORS_NOTIFICATIONS',
          },
          export: {
            group_header: 'ADMIN_EXPORT_GROUP_HEADER',
            export_data: 'ADMIN_EXPORT_EXPORT_DATA',
            download_csv: 'ADMIN_EXPORT_DOWNLOAD_CSV',
          },
        },
        affiliate_menu: {
          home: 'AFFILIATE_HOME',
          tracking_links: {
            group_header: 'TRACKING_LINKS_GROUP_HEADER',
            trackers: 'TRACKING_LINKS_TRACKERS',
            get_creatives_link: 'TRACKING_LINKS_GET_CREATIVES_LINK',
            webhooks: 'TRACKING_LINKS_WEBHOOKS',
            webhooks_history: 'TRACKING_LINKS_WEBHOOKS_HISTORY',
            registration_reference: 'TRACKING_LINKS_REGISTRATION_REFERENCE',
            affiliate_api: 'TRACKING_LINKS_AFFILIATE_API',
          },
          reports: {
            group_header: 'REPORTS_GROUP_HEADER',
            reports: 'REPORTS_REPORTS',
            subaffiliate_reports: 'REPORTS_SUBAFFILIATE_REPORTS',
            creative_reports: 'REPORTS_CREATIVE_REPORTS',
            bookkeeping: 'REPORTS_BOOKKEEPING',
            affiliate_balance: 'REPORTS_AFFILIATE_BALANCE',
          },
          partnership: {
            group_header: 'AFFILIATE_PARTNERSHIP_GROUP_HEADER',
            articles: 'AFFILIATE_PARTNERSHIP_ARTICLES',
            ...buildObjectFromArray(Object.values(EStaticPageName), 'AFFILIATE_PARTNERSHIP_'),
          },
          export: {
            group_header: 'AFFILIATE_EXPORT_GROUP_HEADER',
            download_csv: 'AFFILIATE_EXPORT_DOWNLOAD_CSV',
          },
        },
      },
    },
  }));
}
